<template >
    <v-row> 
        <v-col>
            <v-card
                class="mx-auto first-card"
            >
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">
                            {{ trackedProductsLength }} tracked products of {{ allProductsLength }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-icon x-large>mdi-clock</v-icon>
                </v-list-item>

                <!-- <v-card-actions>
                <v-btn text>Show details</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-col>
         <v-col>
            <v-card
                class="mx-auto"
            >
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">
                            ...
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-icon x-large>mdi-checkbox-blank-circle-outline</v-icon>
                </v-list-item>

                <!-- <v-card-actions>
                <v-btn text>Show details</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-col>
         <v-col>
            <v-card
                class="mx-auto"
            >
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">
                            ....
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-icon x-large>mdi-checkbox-blank-circle-outline</v-icon>
                </v-list-item>

                <!-- <v-card-actions>
                <v-btn text>Show details</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-col>
    </v-row> 
</template>

<script>
  import Vue from 'vue'
  import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';

  export default {
    name: 'HeadCards',
    data () {
      return {
        
      }
    },
    methods:{

    },
    computed : {
      trackedProductsLength (){
        return this.$store.getters.getTrackedProducts.length;
      },
      allProductsLength (){
        return this.$store.getters.getAllProducts.length;
      }
    }
  }
</script>

<style scoped>
    .first-card{
        background-color: rgb(255, 64, 129) !important;
    }
</style>
